'use client';

import Image from 'next/image';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@components/ui/toast';
import { useToast } from '@components/ui/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, courierLogo, ...props }) {
        return (
          <Toast key={id} {...props} className="z-[1000]">
            {courierLogo && (
              <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded bg-amber-50">
                <Image src={courierLogo} alt="" width={22} height={22} className="object-contain" />
              </div>
            )}
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
